import { LocalAudioTrack, LocalVideoTrack } from "twilio-video";

import { useEffect } from "react";

export const useRestartAudioTrackOnDeviceChange = (
  localTracks: (LocalAudioTrack | LocalVideoTrack)[]
) => {
  const audioTrack = localTracks.find((track) => track.kind === "audio");

  useEffect(() => {
    const handleDeviceChange = () => {
      if (audioTrack?.mediaStreamTrack.readyState === "ended") {
        audioTrack.restart({});
      }
    };

    if (navigator.mediaDevices) {
      navigator.mediaDevices.addEventListener(
        "devicechange",
        handleDeviceChange
      );
    }

    return () => {
      if (navigator.mediaDevices) {
        navigator.mediaDevices.removeEventListener(
          "devicechange",
          handleDeviceChange
        );
      }
    };
  }, [audioTrack]);
};
